var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('k-layout',_vm._l((_vm.instances),function(instance){return _c('k-flex',{key:instance.id,attrs:{"c6":""}},[_c('item',{attrs:{"id":instance.id}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }